/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateGroupOrderRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {CreateGroupOrderResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const createGroupOrder = (request:CreateGroupOrderRequest, options?: CashRequestOptions) => post<CreateGroupOrderRequest, CreateGroupOrderResponse>("/2.0/cash/create-group-order", request, {...options, rejectOnError: true })